"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var core_1 = require("@emotion/core");
var Element = styled_1.default.div(function (props) {
  return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &::-webkit-scrollbar {\n      width: ", "px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background-color: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: transparent;\n      border-right-width: ", "px;\n      border-right-style: solid;\n      border-right-color: inherit;\n    }\n  "], ["\n    &::-webkit-scrollbar {\n      width: ", "px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background-color: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: transparent;\n      border-right-width: ", "px;\n      border-right-style: solid;\n      border-right-color: inherit;\n    }\n  "])), props.width || 1, props.width || 1);
});
function Scrollbar(_a) {
  var width = _a.width,
    children = _a.children,
    className = _a.className,
    style = _a.style,
    id = _a.id;
  return react_1.default.createElement(Element, {
    id: id,
    className: className,
    style: style,
    width: width
  }, children);
}
exports.Scrollbar = Scrollbar;
var templateObject_1;